import { useEffect, useState } from "react";
import RestaurantCard from "./RestaurantCard";
import { Link } from "react-router-dom";

import restaurantContext from "./context/restaurantContext";
import { useContext } from "react";
import { filterData } from "../hooks/helpers";

const Body = () => {

    const [resList, setResList] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [allRes, setAllRes] = useState([]);

    const { restaurants } = useContext(restaurantContext);

    useEffect(() => {
        restaurants.then(data => {
            setResList(data);
            setAllRes(data);
        })
    }, [])

    return (
        <>
            <div className="custom-container">
                <div className="grid grid-cols-3 gap-2 my-3">
                    <input
                        type='text'
                        className="p-2 flex-grow border rounded col-span-3 sm:col-span-2"
                        placeholder="Search by restaurant name or area"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                    />
                    <div className="grid grid-cols-2 gap-2 col-span-3 sm:col-span-1">
                        <button
                            className="px-2 py-1 rounded bg-orange-500 text-white col-span-1"
                            onClick={() => {
                                const filteredRes = filterData(searchText, allRes);
                                setResList(filteredRes);
                            }}>
                            Search
                        </button>
                        <button
                            className="px-2 py-1 rounded bg-black text-white col-span-1"
                            onClick={() => {
                                setResList(allRes)
                                setSearchText('')
                            }}
                        >
                            Reset
                        </button>
                    </div>
                </div>
                <div className="grid-config">
                    {
                        resList.length == 0
                            ?
                            <div className="loader"></div>
                            :
                            resList.map(item => {
                                let resImgArr = item?.fields?.restaurant_img
                                let imgUrl = resImgArr ? resImgArr : false

                                return (
                                    <Link to={"/restaurant/" + item?.id} className="card" key={item?.id}>
                                        <RestaurantCard fields={item?.fields} imgUrl={imgUrl} />
                                    </Link>
                                )
                            })
                    }
                </div>
            </div>
        </>
    )
}

export default Body;